import CustomCategorySelector, {
  CustomCategorySelectorProps,
} from "@components/plasmic/custom-options/category-selector";

const HideCategorySelector = (props: CustomCategorySelectorProps) => {
  return <CustomCategorySelector {...props} useRenderedSlugs={true} />;
};

export default HideCategorySelector;
